import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import MainBanner from "../../../components/MainBanner";
import AllConsultants from "../../../components/AllConsultants";
import MultiColumnCTAWithDivider from "../../../components/MultiColumnCTAWithDivider";
import NewColumnWithForm from "components/NewColumnWithForm";

export default function MeetTheTeam({ global, all_consultants }) {
  return (
    <>
      <SeoHead
        page_name={`Meet the SRG Team | Life Sciences Specialists`}
        description={`Meet the dedicated specialists behind SRG, bringing deep experience and industry knowledge to support clients and candidates.`}
        canonical_link={`about-us/meet-the-team`}
      />
      <MainBanner
        global={global}
        pathPrefix={`meet_the_team_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Meet the Team</h1>
          </>
        }
        imageURL1={`/site-assets/images/meet-the-team-main-banner.png`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        breadcrumb_title="Meet The Team"
        secondary_breadcrumb_url={"/about-us"}
        secondary_breadcrumb_title={"About Us"}
      />
      <AllConsultants
        global={global}
        pathPrefix={`meet_the_team_page.all_consultants`}
        customClass={`py-5 grayGradientBg`}
        content={
          <>
            <h2>Our Team</h2>
          </>
        }
        content_2={
          <>
            <h2>Talent Acquisition Team</h2>
          </>
        }
        post={all_consultants}
      />
      {/* <MultiColumnCTAWithDivider
        global={global}
        pathPrefix={`meet_the_team_page.multi_column_cta`}
        customClass={`pt-5 pb-md-4 pb-5`}
        left_content={
          <>
            <h2>Get in Touch</h2>
          </>
        }
        right_content={
          <>
            <h2>Work for us</h2>
          </>
        }
        buttonLink2={`/about-us/join-us`}
        buttonLink1={`/contact-us`}
        buttonTitle1={`Contact us`}
        buttonTitle2={`Join us now`}
      /> */}
      <NewColumnWithForm
        global={global}
        pathPrefix={`us.insights_page.new_column_with_form`}
        customClass={`pb-5`}
        heading={`How can we help you?`}
        formId={`e1da7ff6-feb2-4696-93be-b43ec16b6009`}
        description={
          <>
            <p>
              Contact us if you are interested in finding out more about how we
              can help you.
            </p>
          </>
        }
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const consultants = (await Collection("consultants"))
    .filter(function (post) {
      return post.meet_the_team?.en;
    })
    .filter(function (post) {
      return post.country?.en == "UK";
    });

  const all_consultants = consultants.orderBy("_order").getItems();

  return {
    props: {
      global,
      all_consultants,
    },
  };
}
